import { render, staticRenderFns } from "./FeatureShow.vue?vue&type=template&id=537b705a&"
import script from "./FeatureShow.vue?vue&type=script&lang=js&"
export * from "./FeatureShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports